

export const PAGES_DATA = 
[
	{
		"chapter":"우리는 지금 어디로 가고 있는가",
		"pages": [
			{
				"subject": "[천지성공 1-1] 우리는 어느 때에 살고 있는가",
				"uid": 18640
			},
			{
				"subject": "[천지성공 1-1-2]지금은 문명의 대전환점",
				"uid": 18641
			},
			{
				"subject": "[천지성공 1-2-1] 행복과 성공에 대한 새 이야기의 주인공 증산 상제님",
				"uid": 18642
			},
			{
				"subject": "[천지성공 1-2-2] 온 천하가 큰 병이 들었느니라",
				"uid": 18643
			},
			{
				"subject": "[천지성공 1-3-1] 큰 가을의 때를 맞이한 천지",
				"uid": 18644
			},
			{
				"subject": "[천지성공 1-3-2] 행복과 성공에 대한 새로운 이야기 원전, 『도전道典』",
				"uid": 18645
			}
		]
	}, {
		"chapter":"우주의 가을이 오고있다",
		"pages":[
			{
				"subject": "[천지성공 2-1-1] 인간과 자연이 걸어가는 도道, 생장염장",
				"uid": 18646
			},
			{
				"subject": "[천지성공 2-1-2] 우주에도 1년 사계절이 있다",
				"uid": 18647
			},
			{
				"subject": "[천지성공 2-1-3] 하늘 땅 인간은 같은 주기로 순환한다",
				"uid": 18648
			},
			{
				"subject": "[천지성공 2-1-4] 우주 1년 변화의 목적은",
				"uid": 18649
			},
			{
				"subject": "[천지성공 2-2-1] 지금은 여름과 가을이 바뀌는 하추교역기",
				"uid": 18650
			},
			{
				"subject": "[천지성공 2-2-2] 상극 질서와 원한의 역사",
				"uid": 18651
			},
			{
				"subject": "[천지성공 2-2-3] 여름에서 가을 상생의 세상을 열어 주신 상제님",
				"uid": 18652
			},
			{
				"subject": "[천지성공 2-3-1] 자연개벽, 문명개벽, 인간개벽으로 열리는 후천 세상",
				"uid": 18653
			},
			{
				"subject": "[천지성공 2-3-2] 가을개벽의 근본정신, 원시반본",
				"uid": 18655
			},
			{
				"subject": "[천지성공 2-3-4] 선천 종교와 예지자들이 전한 가을개벽",
				"uid": 18657
			},
			{
				"subject": "[천지성공 2-3-3]인간 열매와 낙엽을 가르는 가을개벽",
				"uid": 18656
			}
		]
	}, {
		"chapter":"인간으로 오신 하나님, 증산 상제님", 
		"pages": [
			{
				"subject": "[천지성공 3-1-1] 온 인류가 받들어 온 상제님",
				"uid": 18658
			},
			{
				"subject": "[천지성공 3-1-2] 상제문화의 핵심 천제와 세계 속 자취",
				"uid": 18659
			},
			{
				"subject": "[천지성공 3-2-1] 상제님은 누구신가",
				"uid": 18660
			},
			{
				"subject": "[천지성공 3-3-2] 상제님의 무궁한 조화 권능",
				"uid": 18662
			},
			{
				"subject": "[천지성공 3-3-1] 마침내 인간으로 오신 상제님",
				"uid": 18661
			},
			{
				"subject": "[천지성공 3-3-3] 상제님은 왜 한반도에 오셨는가",
				"uid": 18663
			},
			{
				"subject": "[천지성공 3-3-4] 상제님의 강세를 예비한 성자들",
				"uid": 18664
			}
		]
	}, {
		"chapter":"인간과 신명세계",
		"pages": [
			{
				"subject": "[천지성공 4-1-1] 인간의 참 모습과 사후 세계",
				"uid": 18665
			},
			{
				"subject": "[천지성공 4-2-1] 상제님이 밝혀 주신 신명 세계",
				"uid": 18666
			},
			{
				"subject": "[천지성공 4-3-1] 조상님은 제1의 하나님",
				"uid": 18667
			},
			{
				"subject": "[천지성공 4-4-1] 지금은 인간과 신명이 해원하는 때",
				"uid": 18668
			},
			{
				"subject": "[천지성공 4-4-2] 원한의 뿌리 단주 해원과 새로운 역사",
				"uid": 18669
			}
		]
	}, {
		"chapter":"내가 이제 하늘도 땅도 뜯어고쳐",
		"pages":[
			{
				"subject": "[천지성공 5-1-1] 내가 이제 하늘도 땅도 뜯어고쳐",
				"uid": 18670
			},
			{
				"subject": "[천지성공 5-2-1] 세계정세와 오선위기",
				"uid": 18672
			},
			{
				"subject": "[천지성공 5-2-2] 애기판과 총각판 씨름",
				"uid": 18673
			},
			{
				"subject": "[천지성공 5-2-3]선천 역사를 매듭짓는 상씨름",
				"uid": 18674
			},
			{
				"subject": "[천지성공 5-3-1] 상제님의 종통 전수, 도운 공사",
				"uid": 18675
			}
		]		
	}, {
		"chapter":"가을개벽을 넘어 구원의 길로",
		"pages": [
			{
				"subject": "[천지성공 6-1-1] 가을개벽을 넘어 구원의 길로",
				"uid": 18676
			},
			{
				"subject": "[천지성공 6-1-2] 난리가 나가고 병이 들어오리라",
				"uid": 18677
			},
			{
				"subject": "[천지성공 6-1-3] 가을개벽으로 들어가는 통과의례, 병겁",
				"uid": 18678
			},
			{
				"subject": "[천지성공 6-1-4] 가을 천지로 들어서는 출발점, 지축 정립",
				"uid": 18682
			},
			{
				"subject": "[천지성공 6-2-1] 가을에 소멸되는 자와 구원받는 자",
				"uid": 18683
			},
			{
				"subject": "[천지성공 6-2-2] 구원의 법방 의통과 태을주",
				"uid": 18684
			},
			{
				"subject": "[천지성공 6-3-1] 의통과 태을주를 전수받는 길",
				"uid": 18685
			}
		]
	}, {
		"chapter": "후천 조화선경과 참된 성공의 길",
		"pages": [
			{
				"subject": "[천지성공 7-1-1] 자연개벽 - 신천지 조화선경",
				"uid": 18686
			},
			{
				"subject": "[천지성공 7-1-2] 문명개벽 - 선경문명의 참 모습",
				"uid": 18687
			},
			{
				"subject": "[천지성공 7-1-3] 인간개벽 - 선경문화의 주인공, 선仙",
				"uid": 18688
			},
			{
				"subject": "[천지성공 7-2-1] 천지 꿈을 실현하는 일꾼, 태일",
				"uid": 18689
			},
			{
				"subject": "[천지성공 7-2-2] 지금은 천지에서 사람을 크게 쓰는 때",
				"uid": 18690
			}
		]
	}
];

